"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext } from "react";
import { CarouselContext } from "../CarouselContext";
import styles from "./SlideBreadcrumbs.module.css";
export default function SlideBreadcrumbs(t0) {
  const $ = _c(6);
  const {
    numSlides
  } = t0;
  const {
    activeIndex,
    setActiveIndex
  } = useContext(CarouselContext);
  let t1;
  if ($[0] !== numSlides) {
    t1 = Array.from({
      length: numSlides
    });
    $[0] = numSlides;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activeIndex || $[3] !== setActiveIndex || $[4] !== t1) {
    t2 = <div className={styles.slideBreadcrumbs}>{t1.map((_, index) => <span key={index} data-active={index === activeIndex} role="button" className={styles.breadcrumbDot} onClick={() => setActiveIndex(index)} />)}</div>;
    $[2] = activeIndex;
    $[3] = setActiveIndex;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}